import React from 'react';
import { WebinarsHeading } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData } from "@storyblok/react";

interface WebinarsHeadingProps {
  blok: WebinarsHeading & SbBlokData;
}

const WebinarsHeadingComponent: React.FC<WebinarsHeadingProps> = ({ blok }) => {
  const { type, date, date_end, speaker, address, cta_text, cta_link } = blok;

  const formatDateTime = (dateString: string | undefined, endDateString?: string | undefined) => {
    if (!dateString) return '';

    try {
      const startDate = new Date(dateString);
      const day = startDate.getDate();
      const month = startDate.toLocaleString('en-US', { month: 'long' });
      const year = startDate.getFullYear();
      const startTime = startDate.toLocaleString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });

      if (type === 'events' && endDateString) {
        const endDate = new Date(endDateString);
        const endTime = endDate.toLocaleString('en-GB', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });
        return `${day} ${month} ${year}, ${startTime}-${endTime}`;
      }

      return `${day}${getOrdinalSuffix(day)} ${month} ${year} @ ${startTime} BST`;
    } catch {
      return dateString;
    }
  };

  const getOrdinalSuffix = (day: number): string => {
    const j = day % 10;
    const k = day % 100;
    if (j === 1 && k !== 11) return 'st';
    if (j === 2 && k !== 12) return 'nd';
    if (j === 3 && k !== 13) return 'rd';
    return 'th';
  };

  if (type === 'events') {
    return (
      <div className="event-info-strip">
        <div className="container">
          <div className="row">
            <div className="col-24 col-md-12">
              <i className="far fa-calendar" aria-hidden="true"></i>
              <span>{formatDateTime(date, date_end)}</span>
            </div>
            <div className="col-24 col-md-12">
              <i className="fas fa-map-marker-alt" aria-hidden="true"></i>
              <span>{address}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="event-info-strip event-webinar">
      <div className="container">
        <div className="row">
          <div className="col-24 col-md-8">
            <i className="far fa-calendar" aria-hidden="true"></i>
            <span>{formatDateTime(date)}</span>
          </div>
          {speaker && (
            <div className="col-24 col-md-8">
              <i className="fas fa-microphone" aria-hidden="true"></i>
              <span>{speaker}</span>
            </div>
          )}
          {cta_link?.url && (
            <div className="col-24 col-md-8">
              <i className="fas fa-globe" aria-hidden="true"></i>
              <span>
                <a
                  className="text-white"
                  href={cta_link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {cta_text || 'Click to watch'}
                </a>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WebinarsHeadingComponent;